export default class FiltroHoteles {
  constructor(filtro, todos) {
    this.filtro = filtro
    this.todos = JSON.parse(JSON.stringify(todos))
    this.filtrados = []
    this.filtrar()
  }
  filtrar() {
    var byHoteles = this.byHotelesSelected(this.filtro.hoteles)
    byHoteles = byHoteles.length > 0 ? byHoteles : this.todos
    var byCategorias = this.byCategorias(byHoteles)
    var byrango = this.byRango(byCategorias)
    const planesTkts = this.byPlanesTickets(byrango)
    if (this.filtro.ordenamiento == 0) {
      planesTkts.sort((a, b) => (a.nombre > b.nombre ? 1 : b.nombre > a.nombre ? -1 : 0))
    }
    if (this.filtro.orderBy != 0) {
      planesTkts.sort((a, b) => Number(a.masEconomico) - Number(b.masEconomico))
      if (this.filtro.orderBy == 2) {
        planesTkts.reverse()
      }
    }
    let sinDispo = this.getHotelesSinDispo()
    var filtrados = { hoteles: planesTkts, sinDispo: sinDispo }
    this.filtrados = filtrados
  }
  byHotelesSelected(hoteles) {
    var filtrados = []
    for (let h of hoteles) {
      var seleccionados = this.todos.filter(hotel => h === hotel["@attributes"].id)
      filtrados = filtrados.concat(seleccionados)
    }
    return filtrados
  }
  byCategorias(filtrados) {
    var byCategorias = []
    for (let c of this.filtro.categorias) {
      if (c.activo) {
        var encontrado = filtrados.filter(f => c.estrella == f.categoria)
        byCategorias = byCategorias.concat(encontrado)
      }
    }
    return byCategorias
  }
  byRango(filtrados) {
    var min = this.filtro.slider.value[0]
    var max = this.filtro.slider.value[1]
    var byRango = filtrados.filter(
      f =>
        (parseInt(f.masEconomico) >= min && parseInt(f.masEconomico) <= max) ||
        (parseInt(f.masCara) >= min && parseInt(f.masCara) <= max)
    )
    return byRango
  }
  getFiltrados() {
    return this.filtrados
  }
  getHotelesSinDispo() {
    return this.todos.filter(h => {
      if (h.disponible === "false") {
        return true
      }
      if (Object.entries(h.habitaciones).length === 0) {
        return true
      }

      return false
    })
  }
  byPlanesTickets(data) {
    const planesActivos = this.filtro.planes.filter(p => p.activo)
    const ticketsActivos = this.filtro.pases.filter(p => p.activo)
    const mapped = data.map(d => {
      if (d.proveedor != 11) {
        return d
      }
      const habs = Array.isArray(d.habitaciones.habitacion) ? d.habitaciones.habitacion : [d.habitaciones.habitacion]
      const filtrados = habs
        .filter(h => planesActivos.some(pla => pla.id == h.comidaTipo))
        .filter(h => ticketsActivos.some(tka => tka.id == h.ticketTipo))
      d.habitaciones.habitacion = filtrados
      return d
    })
    return mapped
  }
}
